import { memo } from "react";

import { Icon } from "@react/components/Icon/Icon.view";
import { type TTailwindString, tw } from "classnames";

type Props = {
  className?: TTailwindString;
  rating: number;
  size?: "sm" | "md";
};

const ReviewStarsBase = ({ className, rating, size = "md" }: Props) => {
  const starIconSizeClassName =
    size === "md" ? tw("w-6", "h-6") : tw("w-4", "h-4");
  return (
    <div className={className}>
      {[...Array(5).keys()].map((number) => {
        if (rating - number >= 1) {
          return (
            <Icon
              className={starIconSizeClassName}
              key={`full-star-${number}`}
              name="star-full"
            />
          );
        }
        if (rating - number <= 0) {
          return (
            <Icon
              className={starIconSizeClassName}
              key={`empty-star-${number}`}
              name="star-empty"
            />
          );
        }
        return (
          <Icon
            className={starIconSizeClassName}
            key={`half-full-star-${number}`}
            name="star-half-full"
          />
        );
      })}
    </div>
  );
};

export const ReviewStars = memo(ReviewStarsBase);
